import React, { useState } from 'react'
import classnames from 'classnames'
import style from './InformaBanner.module.scss'
import informaLogo from './logo.svg'

interface BannerProps {
  lineMessage?: string
  leadCopy?: string
}

const downArrow = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAABHNCSVQICAgIfAhkiAAAAIBJREFUKFNj/P//fwIDA0M/EAsAMTngA1BTISPQIBCDnxwTkPR8ABl0AChgT6FBB0EGGQANARlGrqs+AvU6MIJcQoFhEEMYGS+ADSLTMLghIP1wg0g0DMUQDIOINAzDEKwGETAMqyE4DcJhGE5D8BoENUwBSE+AxkcBMHYe4EpvACnxPT9OqFuzAAAAAElFTkSuQmCC"
const infoIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABHNCSVQICAgIfAhkiAAAAalJREFUSEuVlY1RwzAMhfEEwARkg5YJaCaATtAwAWUCYALKBKQTtExA2KCdALpBNwjvGak4OcdyfKdLLpY+yfpx3FlitW17h+1bSAGZieoPnpQt5MM5x/focrGvgFb4/iTQlH/urSAvcHLsK3bggF5A4R3CiMcsgks42IVGJ7iAP7E5NahfonPe06ODORw0+j2E8+ONAWZ0jQTCXMccXGsdPFxyzHQkF4xygmmgVhKkcEZxZcGx74snNUkF40/opN02GeAxKmvAK8JrWC0MyzX22QksWpVRmyPgl4RbheSwEPymvQwbOukXsx9fSXibeV6fR2kAOpsYdqPgbDE/JJkBeXhOpxwALgTM6c1pAA+3ck6mr77A2Y4PGan0BV1C8dVQvge8HpHvPfSnhPO432Zx/ouZk8ZHwFc6odZRt1CeawDG4J3qo3BetYwo1bvcp/DWpP7Q4s3I2fi7WySXNGoMB1Yd+dN4VqX+z2KGDXq1pi/mpAPuRB6coMB7DbHudjU54GWpqQi9Rv+hkiaeooJwaGIn2TMIdsVQrgbhoQG6g47CtdNLLFWEX6p9sxmf9HCxAAAAAElFTkSuQmCC"

const InformaBanner: React.FC<BannerProps> = ({
  lineMessage = "TechTarget and Informa Tech's Digital Businesses Combine.",
  leadCopy = "Together, we power an unparalleled network of 220+ online properties covering 10,000+ granular topics, serving an audience of 50+ million professionals with original, objective content from trusted sources. We help you gain critical insights and make more informed decisions across your business priorities."
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const toggleExpand = (): void => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={classnames(style['light'], style['banner'])}>
        <div className={classnames(style['container'])}>
            <div className={classnames(style['line-message'])}>
                <button
                    className={classnames(style['btn-toggle'])}
                    onClick={toggleExpand}>
                    <img className={classnames(style['logo-text'])} src={informaLogo} alt="Informa Logo" />
                    <img className={classnames(style['icon-downArrow'], isExpanded && style['show'])} 
                      src={downArrow} 
                      alt="Toggle" 
                    />
              </button>
              <p>
                <img className={classnames(style['icon-info'])} src={infoIcon} alt="Info" />
                <span className={classnames(style['lang-lineMessage'])}>{lineMessage}</span>
              </p>
            </div>
          <div className={classnames(style['expanded-message-detail'], isExpanded && style['show'])}>
            <p className={classnames(style['en'], style['lead-copy'])}>
                <span className={classnames(style['lang-leadCopy'])}>{leadCopy}</span>
            </p>
        </div>
      </div>
    </div>
  )
}

export default InformaBanner